import * as React from "react";
import { JSX } from "react/jsx-runtime";

const HelpSupportIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Headset Arch */}
    <path
      d="M3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11"
      stroke="#4682B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Left Earpad */}
    <rect
      x="2"
      y="11"
      width="4"
      height="7"
      rx="2"
      stroke="#4682B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Right Earpad */}
    <rect
      x="18"
      y="11"
      width="4"
      height="7"
      rx="2"
      stroke="#4682B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Microphone Arm */}
    <path
      d="M20 18V19C20 20.6569 18.6569 22 17 22H14"
      stroke="#4682B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Microphone Tip */}
    <circle cx="13" cy="22" r="1.25" fill="#4682B4" />
  </svg>
);

export default HelpSupportIcon;
